import React from "react";
import ReactDOM from "react-dom";
import "./ConfirmationDialog.css";

const ConfirmationDialog = ({ title, message, onConfirm, onCancel }) => {
  return ReactDOM.createPortal(
    <div className="confirmation-dialog-backdrop">
      <div className="confirmation-dialog">
        <h5>{title || "Confirm"}</h5>
        <p>{message || "Are you sure?"}</p>
        <div className="dialog-actions">
          <button className="btn btn-danger me-2" onClick={onConfirm}>Yes</button>
          <button className="btn btn-secondary" onClick={onCancel}>No</button>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default ConfirmationDialog;
